import { Action } from '@ngrx/store';

import { AggregateDataSectionGroupInterface } from '../models/aggregate-data-section-group.model';

import { AssessmentResultsActionType } from './assessment-results-action-type.enum';

export class LoadAssessmentResults implements Action {
  public readonly type: AssessmentResultsActionType = AssessmentResultsActionType.LoadAssessmentResults;
  public readonly payload: any = undefined;
}

export class LoadAssessmentResultsComplete implements Action {
  public readonly type: AssessmentResultsActionType = AssessmentResultsActionType.LoadAssessmentResultsComplete;

  constructor(public readonly payload: {[id: string]: AggregateDataSectionGroupInterface}) { }
}

export class LoadQuestionDetails implements Action {
  public readonly type: AssessmentResultsActionType = AssessmentResultsActionType.LoadQuestionDetails;

  constructor(public readonly payload: string) { }
}

export class LoadQuestionDetailsComplete implements Action {
  public readonly type: AssessmentResultsActionType = AssessmentResultsActionType.LoadQuestionDetailsComplete;

  constructor(readonly payload: any) {}
}
